import { useEffect, useState } from "react";

import { isAuth } from "@/network/helper";

import LICENSE_STATUS from "@/constants/licenseStatus";
import useUser from "@/components/layout/useUser";

function useLicenseActive() {
  
    const isAuthenticated = isAuth();

    const {userData : user} = useUser(isAuthenticated);

    const [isLicenseActive, setIsLicenseActive] = useState(user?.attributes?.license_status == LICENSE_STATUS.FULL_ACCESS);
    
      useEffect(() => {
        if (user?.attributes?.license_status === LICENSE_STATUS.VIEW_ONLY) {
          setIsLicenseActive(false);
        } else if(user?.attributes?.license_status === LICENSE_STATUS.FULL_ACCESS) {
          setIsLicenseActive(true);
        }
      }, [user?.attributes?.license_status]);         
          
      return isLicenseActive;
}


export default useLicenseActive;


